import { Record, Union } from "../fable_modules/fable-library-js.4.25.0/Types.js";
import { bool_type, string_type, option_type, list_type, record_type, int32_type, union_type, float64_type } from "../fable_modules/fable-library-js.4.25.0/Reflection.js";
import { interpolate, toText } from "../fable_modules/fable-library-js.4.25.0/String.js";
import { exists, collect, singleton, ofArray } from "../fable_modules/fable-library-js.4.25.0/List.js";
import { ComponentVisibility, ComponentVisibility_$reflection } from "../ThreeDocs.SharedUI/ComponentVisibility.js";
import { map, defaultArg } from "../fable_modules/fable-library-js.4.25.0/Option.js";
import { FileData_$reflection } from "../Common/FileData.js";

export class FileManagementProgress extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["InProgress", "Done"];
    }
}

export function FileManagementProgress_$reflection() {
    return union_type("ThreeDocs.Client.FileManagement.Shared.FileManagementProgress", [], FileManagementProgress, () => [[["Item", float64_type]], []]);
}

export function FileManagementProgress_get_describe() {
    return (_arg) => ((_arg.tag === 1) ? "Uploaded" : toText(interpolate("%.0f%P()%% uploaded", [_arg.fields[0]])));
}

export class FileType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Pdf", "Jpeg", "Png", "Mp4", "Mkv", "Mov"];
    }
}

export function FileType_$reflection() {
    return union_type("ThreeDocs.Client.FileManagement.Shared.FileType", [], FileType, () => [[], [], [], [], [], []]);
}

export function FileType_get_all() {
    return ofArray([new FileType(0, []), new FileType(1, []), new FileType(2, []), new FileType(3, []), new FileType(4, []), new FileType(5, [])]);
}

export function FileType_get_getExtensions() {
    return (_arg) => ((_arg.tag === 1) ? ofArray([".jpg", ".jpeg"]) : ((_arg.tag === 2) ? singleton(".png") : ((_arg.tag === 3) ? singleton(".mp4") : ((_arg.tag === 4) ? singleton(".mkv") : ((_arg.tag === 5) ? singleton(".mov") : singleton(".pdf"))))));
}

export function FileType_asExtensions_ZE4BC757(fileTypes) {
    return collect(FileType_get_getExtensions(), fileTypes);
}

export class MaximumFiles extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Unlimited", "Limited"];
    }
}

export function MaximumFiles_$reflection() {
    return union_type("ThreeDocs.Client.FileManagement.Shared.MaximumFiles", [], MaximumFiles, () => [[], [["Item", int32_type]]]);
}

export class FileComponentVisibility extends Record {
    constructor(uploadComponentVisibility, uploadButtonVisibility, downloadButtonVisibility, deleteButtonVisibility) {
        super();
        this.uploadComponentVisibility = uploadComponentVisibility;
        this.uploadButtonVisibility = uploadButtonVisibility;
        this.downloadButtonVisibility = downloadButtonVisibility;
        this.deleteButtonVisibility = deleteButtonVisibility;
    }
}

export function FileComponentVisibility_$reflection() {
    return record_type("ThreeDocs.Client.FileManagement.Shared.FileComponentVisibility", [], FileComponentVisibility, () => [["uploadComponentVisibility", ComponentVisibility_$reflection()], ["uploadButtonVisibility", ComponentVisibility_$reflection()], ["downloadButtonVisibility", ComponentVisibility_$reflection()], ["deleteButtonVisibility", ComponentVisibility_$reflection()]]);
}

export function FileComponentVisibility_downloadOnly_Z3014299D(downloadButtonVisibility) {
    return new FileComponentVisibility(new ComponentVisibility(1, []), new ComponentVisibility(1, []), downloadButtonVisibility, new ComponentVisibility(1, []));
}

export function FileComponentVisibility_get_fileSystemUpload() {
    return new FileComponentVisibility(new ComponentVisibility(0, []), new ComponentVisibility(0, []), new ComponentVisibility(0, []), new ComponentVisibility(0, []));
}

export function FileComponentVisibility_get_autoZipUpload() {
    return new FileComponentVisibility(new ComponentVisibility(0, []), new ComponentVisibility(1, []), new ComponentVisibility(0, []), new ComponentVisibility(0, []));
}

export class FileComponentSpecs extends Record {
    constructor(maybeFileTypeRestrictions, uploadDestinationPath, maxFiles) {
        super();
        this.maybeFileTypeRestrictions = maybeFileTypeRestrictions;
        this.uploadDestinationPath = uploadDestinationPath;
        this.maxFiles = maxFiles;
    }
}

export function FileComponentSpecs_$reflection() {
    return record_type("ThreeDocs.Client.FileManagement.Shared.FileComponentSpecs", [], FileComponentSpecs, () => [["maybeFileTypeRestrictions", option_type(list_type(FileType_$reflection()))], ["uploadDestinationPath", string_type], ["maxFiles", MaximumFiles_$reflection()]]);
}

export function FileComponentSpecs__isFileExtensionAllowed_Z721C83C5(this$, fileName) {
    return defaultArg(map((arg) => exists((extension) => fileName.toLocaleLowerCase().endsWith(extension), FileType_asExtensions_ZE4BC757(arg)), this$.maybeFileTypeRestrictions), true);
}

export class UploadSelection extends Record {
    constructor(files, triggerUpload) {
        super();
        this.files = files;
        this.triggerUpload = triggerUpload;
    }
}

export function UploadSelection_$reflection() {
    return record_type("ThreeDocs.Client.FileManagement.Shared.UploadSelection", [], UploadSelection, () => [["files", list_type(FileData_$reflection())], ["triggerUpload", bool_type]]);
}

